import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Crown, Check, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

export const BrandsCta = () => {
  const { t } = useLang();
  const b = t.brandSection;
  return (
    <section data-testid="brands-cta-section" className="relative py-24 sm:py-32 bg-[#050505] overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative border border-[#d4af37]/25 bg-gradient-to-br from-[#0e0b06] via-[#0a0a0a] to-[#050505] p-10 sm:p-16"
        >
          <span className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#d4af37]/50 to-transparent" />
          <span className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#d4af37]">
            <Crown size={14} /> {b.kicker}
          </span>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl mt-5 text-white max-w-2xl">
            {b.title}<span className="text-[#d4af37]">.</span>
          </h2>
          <p className="mt-5 max-w-2xl text-white/60 font-light text-sm sm:text-base lg:text-lg">{b.subtitle}</p>
          <ul className="mt-8 grid sm:grid-cols-3 gap-4">
            {b.points.map((p, i) => (
              <li key={p} data-testid={`brand-point-${i}`} className="flex items-start gap-2.5 text-sm text-white/75">
                <Check size={16} className="text-[#d4af37] mt-0.5 shrink-0" /> {p}
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to="/register?role=brand"
              data-testid="brand-create-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#d4af37] text-black font-medium px-7 py-3.5 hover:bg-[#f3e5ab] transition-colors"
            >
              {b.cta} <ArrowRight size={16} />
            </Link>
            <Link
              to="/espace-marques"
              data-testid="brand-discover-btn"
              className="inline-flex items-center justify-center gap-2 border border-[#d4af37]/40 text-[#d4af37] px-7 py-3.5 hover:bg-[#d4af37]/10 transition-colors"
            >
              {b.secondary}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
